import React, { useState, useRef, useEffect } from "react";
import FeatherIcon from "feather-icons-react";

const sortOptions = [
  { value: "interest", label: "İlgiye Göre" },
  { value: "year_desc", label: "Yıla göre azalan" },
  { value: "year_asc", label: "Yıla göre artan" },
];

const pageSizeOptions = [
  { value: 20, label: "20" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export default function SortAndActionsBar({
  onSortChange,
  onSaveClick,
  onSelectAll,
  onShareSearch,
  onPageSizeChange,
  selectedSort,
  selectedPageSize,
  selectedFilters,
}) {
  // --- Dropdown (mobil) state'leri
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownTimeout = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(dropdownTimeout.current);
    setDropdownOpen(true);
  };
  const handleMouseLeave = () => {
    dropdownTimeout.current = setTimeout(() => setDropdownOpen(false), 200);
  };

  // --- Kaydet aksiyonları için spam koruması
  const [saving, setSaving] = useState(false);
  const [savingKind, setSavingKind] = useState(null); // 'excel' | 'search' | 'multifavorite' | null
  const savingRef = useRef(false);

  const doSave = async (kind) => {
    if (savingRef.current) return; // tekrar tıklamaları yut
    savingRef.current = true;
    setSaving(true);
    setSavingKind(kind);
    try {
      await onSaveClick(kind); // parent fonksiyon (async)
    } finally {
      // küçük bir cooldown: double-click’leri keser
      setTimeout(() => {
        savingRef.current = false;
        setSaving(false);
        setSavingKind(null);
      }, 800);
    }
  };

  // Masaüstü içerik
  const sortActionsContent = (
    <div
      className="d-flex flex-wrap flex-md-nowrap align-items-center gap-2"
      style={{ fontSize: "0.90em" }}
    >
      {/* Sırala */}
      <select
        className="form-select rounded-2 form-select-sm"
        value={selectedSort}
        onChange={(e) => onSortChange(e.target.value)}
        style={{
          minWidth: 135,
          maxWidth: 160,
          fontSize: "0.90em",
          padding: "0.25rem 0.5rem",
        }}
      >
        {sortOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {/* Göster */}
      <select
        className="form-select form-select-sm rounded-2"
        value={selectedPageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        style={{
          minWidth: 80,
          maxWidth: 100,
          fontSize: "0.90em",
          padding: "0.25rem 0.5rem",
        }}
      >
        {pageSizeOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {/* Kaydet Dropdown */}
      <div className="dropdown hover-open">
        <button
          className="border text-newdarkfume bg-white rounded-2 dropdown-toggle"
          type="button"
          id="saveDropdownDesktop"
          style={{ fontSize: "0.90em", padding: "0.25rem 0.5rem" }}
          disabled={saving}                 // <-- kilit
          aria-disabled={saving}
        >
          {saving ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              />
              Kaydet
            </>
          ) : (
            <>
              <span className="d-none d-md-inline">Kaydet</span>
              <i className="fa-regular fa-floppy-disk d-inline d-md-none" />
            </>
          )}
        </button>

        <ul
          className="dropdown-menu"
          aria-labelledby="saveDropdownDesktop"
          style={{ minWidth: 170, maxHeight: "60vh", overflowY: "auto" }}
        >
          <li>
            <button
              className="dropdown-item"
              style={{ fontSize: "0.90em" }}
              onClick={() => doSave("excel")}
              disabled={saving}
            >
              Excel olarak kaydet
            </button>
          </li>
          <li>
            <button
              className="dropdown-item"
              style={{ fontSize: "0.90em" }}
              onClick={() => doSave("search")}
              disabled={saving}
            >
              Aramayı kaydet
            </button>
          </li>
          <li>
            <button
              className="dropdown-item"
              style={{ fontSize: "0.90em" }}
              onClick={() => doSave("multifavorite")}
              disabled={saving}
            >
              Klasöre kaydet
            </button>
          </li>
        </ul>
      </div>

      |

      {/* Hepsini Seç */}
      <button
        className="border bg-white rounded-2 text-newdarkfume "
        style={{ fontSize: "0.90em", padding: "0.25rem 0.5rem" }}
        onClick={onSelectAll}
      >
        <span
          className="d-none d-md-inline"
          style={{ whiteSpace: "nowrap", minWidth: 110 }}
        >
          Hepsini Seç
        </span>
        <i className="fa fa-check-square d-inline d-md-none" />
      </button>

      {/* Aramayı paylaş */}
      <button
        className="btn-sm bg-transparent border-0 text-sm text-decoration-underline"
        style={{ fontSize: "0.90em" }}
        onClick={onShareSearch}
      >
        <span
          className="d-none d-md-inline text-newdarkfume "
          style={{ whiteSpace: "nowrap", minWidth: 110, fontSize: "0.90em" }}
        >
          Aramayı paylaş
        </span>
        <i className="fa fa-share-alt d-inline d-md-none" />
      </button>
    </div>
  );

  return (
    <>
      {/* Mobil toolbar */}
      <div
        className="row d-md-none gx-1 px-2 mb-2 w-100 mx-0 px-0"
        style={{ fontSize: "0.80em" }}
      >
        <div className="col">
          <select
            className="form-select form-select-sm"
            style={{
              fontSize: "0.80em",
              padding: "2px 4px",
              minWidth: 0,
              textOverflow: "ellipsis",
            }}
            value={selectedSort}
            onChange={(e) => onSortChange(e.target.value)}
          >
            <option value="interest">İlgi</option>
            <option value="year_desc">Yıl ↓</option>
            <option value="year_asc">Yıl ↑</option>
          </select>
        </div>

        <div className="col">
          <select
            className="form-select form-select-sm"
            style={{ fontSize: "0.80em", padding: "2px 4px", minWidth: 0 }}
            value={selectedPageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {/* Kaydet (mobil) */}
        <div className="col d-flex justify-content-start">
          <div
            className="dropdown w-100"
            ref={dropdownRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className="btn btn-outline-secondary btn-sm w-100"
              type="button"
              id="saveDropdownMobile"
              aria-expanded={dropdownOpen ? "true" : "false"}
              onClick={() => setDropdownOpen((open) => !open)}
              style={{ fontSize: "0.80em", padding: "2px 4px" }}
              disabled={saving}                 // <-- kilit
              aria-disabled={saving}
            >
              {saving ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="fa-regular fa-floppy-disk" />
              )}
            </button>

            <ul
              className={`dropdown-menu${dropdownOpen ? " show" : ""}`}
              aria-labelledby="saveDropdownMobile"
              style={{ minWidth: 170 }}
            >
              <li>
                <button
                  className="dropdown-item"
                  style={{ fontSize: "0.80em" }}
                  onClick={() => {
                    setDropdownOpen(false);
                    doSave("excel");
                  }}
                  disabled={saving}
                >
                  Excel olarak kaydet
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  style={{ fontSize: "0.80em" }}
                  onClick={() => {
                    setDropdownOpen(false);
                    doSave("search");
                  }}
                  disabled={saving}
                >
                  Aramayı kaydet
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  style={{ fontSize: "0.80em" }}
                  onClick={() => {
                    setDropdownOpen(false);
                    doSave("multifavorite");
                  }}
                  disabled={saving}
                >
                  Klasöre kaydet
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Hepsini seç */}
        <div className="col d-flex justify-content-center">
          <button
            className="btn btn-outline-primary btn-sm w-100"
            style={{ fontSize: "0.80em", padding: "2px 4px" }}
            onClick={onSelectAll}
          >
            <i className="fa fa-check-square" />
          </button>
        </div>

        {/* Aramayı paylaş */}
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-outline-primary btn-sm w-100"
            style={{ fontSize: "0.80em", padding: "2px 4px" }}
            onClick={onShareSearch}
          >
            <i className="fa fa-share-alt" />
          </button>
        </div>
      </div>

      {/* Masaüstü */}
      <div className="row gx-2 mx-2 gy-2 align-items-center justify-content-center pb-0 d-none d-md-block">
        <div className="col-12">{sortActionsContent}</div>
      </div>
    </>
  );
}
